import { object } from 'yup';
import type { ValidationErrors } from 'final-form';
import type { ObjectSchema } from 'yup';
import type { ObjectShape } from 'yup/lib/object';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';
import { organizationCardStore } from '@stores/dictionaryStores/organizationsStore/organizationCardStore';

export const organization = (head: boolean): ObjectSchema<ObjectShape> => {
  const { isNew } = organizationCardStore;
  const { organizations } = organizationsStore;

  return object().shape({
    companyCode: textValidator({ fieldName: 'companyCode' }),
    code: textValidator({ fieldName: 'code', maxLength: 10, required: true, withoutSpaces: true })
      .test('code', 'Код организации должен быть уникальным', (code) => {
        if (isNew) {
          const current = organizations.find((org) => org.code === code);
          if (current) return false;
        }
        return true;
      })
      .test('code', 'Код организации не должен начинаться с точки', (code) => code?.[0] !== '.')
      .test('code', 'Код организации не должен заканчиваться точкой', (code) => code?.at(-1) !== '.'),
    organizationTypeCode: textValidator({ fieldName: 'organizationTypeCode', maxLength: 10, required: !head }),
  });
};

export const validate = (
  head: boolean,
): ((values: unknown) => ValidationErrors | Promise<ValidationErrors> | undefined) =>
  createValidator(organization(head));
